import { TextField } from '@mui/material'
import { GridRowId, useGridApiContext } from '@mui/x-data-grid-premium'
import { FC, useEffect, useState } from 'react'
import { isOrgSupplier } from '@omnea-app/fe-form-viewer/types/supplierProduct'
import { useSuppliersAndProductsSearch } from '@omnea-app/fe-form-viewer/useSupplierAndProductsSearch'
import { BaseAutocomplete } from '@omnea-app/omui/BaseAutocomplete'

type Props = {
  selectedSupplierId?: string
  id: GridRowId
}

export const RenderEditSupplierCell: FC<Props> = ({ selectedSupplierId, id }) => {
  const apiRef = useGridApiContext()

  const [supplierInput, setSupplierInput] = useState('')

  const { options, search, isLoading } = useSuppliersAndProductsSearch({
    includeGlobal: false,
    limit: 50,
    enableOverride: true,
  })

  const selectedSupplier = options.find((option) => option.id === selectedSupplierId)
  useEffect(() => {
    void search(supplierInput === '' ? '%' : supplierInput)
  }, [supplierInput, search])
  return (
    <BaseAutocomplete
      loading={isLoading}
      value={selectedSupplier || null}
      onChange={async (_event, supplier) => {
        await apiRef.current?.setEditCellValue({
          id,
          field: 'supplier',
          value: supplier
            ? {
                id: supplier.id,
                name: supplier.name,
              }
            : null,
        })
        apiRef.current?.stopCellEditMode({ id, field: 'supplier' })
      }}
      getOptionLabel={(option) => option.name}
      onInputChange={(_e, value: string) => {
        setSupplierInput(value)
      }}
      options={options.filter(isOrgSupplier)}
      renderInput={(params) => <TextField {...params} />}
      sx={{ minWidth: 200 }}
    />
  )
}
